import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { bookOnVrbo } from "@/lib/booking";
import { PROPERTY } from "@/data/property";

const LINKS = [
  { href: "#story", label: "The House" },
  { href: "#gallery", label: "Gallery" },
  { href: "#amenities", label: "Amenities" },
  { href: "#baseball", label: "Rocker B" },
  { href: "#contact", label: "Contact" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-background/70 border-b border-black/5 py-3" : "py-5"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a
          href="#top"
          data-testid="site-logo"
          className={`font-display text-2xl md:text-[1.7rem] leading-none tracking-tight transition-colors ${
            scrolled ? "text-foreground" : "text-white"
          }`}
        >
          PK <span className="italic">Lake House</span>
        </a>

        <div className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-xs uppercase tracking-[0.18em] transition-colors ${
                scrolled ? "text-muted-foreground hover:text-foreground" : "text-white/80 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => bookOnVrbo("nav")}
          data-testid="nav-book-button"
          className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-xs md:text-sm font-medium tracking-wide transition-all duration-300 hover:gap-3 ${
            scrolled
              ? "bg-primary text-primary-foreground hover:bg-primary/90"
              : "bg-white text-primary hover:bg-white/90"
          }`}
        >
          Book on VRBO
          <span aria-hidden>&rarr;</span>
        </button>
      </nav>
    </motion.header>
  );
}
